import { ToneDto } from '../tonedto';

export interface GetMusicBoxContentsDto
{
    getToneCode(): string;
    getLanguage(): string;
    getType(): string;
    getPageNo(): string;
    getPerPageCount(): string;

    getListOfMusicBoxContentsTones(): ToneDto[];
/* toneCode
language
type
pageNo
perPageCount
sortBy
alignBy
childContents
operator  */
}

export class GetMusicBoxContentsDtoImpl implements GetMusicBoxContentsDto
{
    private toneCode: string;
    private language: string;
    private type: string;
    private pageNo: string;
    private perPageCount: string;
    private musicBoxContentsTonesList: ToneDto[];

    getToneCode(): string
    {
        return this.toneCode;
    }
    setToneCode(toneCode: string)
    {
        this.toneCode = toneCode;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }  

    setType(type: string)
    {
        this.type = type;
    }
    getType(): string 
    {
        return this.type;
    }   

    setPageNo(pageNo: string)
    {
        this.pageNo = pageNo;
    }
    getPageNo(): string 
    {
        return this.pageNo;
    }

    setPerPageCount(perPageCount: string)
    {
        this.perPageCount = perPageCount;
    }
    getPerPageCount(): string 
    {
        return this.perPageCount;
    }

    getListOfMusicBoxContentsTones(): ToneDto[]
    {
        return this.musicBoxContentsTonesList;
    }
    setListOfMusicBoxContentsTones(musicBoxContentsTonesList: ToneDto[])
    {
        this.musicBoxContentsTonesList = musicBoxContentsTonesList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/musicboxcontents/getmusicboxcontentsdto.ts